/**
 * Address-book duplicate rejections.
 *
 * The portal refuses to store two entries of the same role (shipper vs consignee) carrying the same
 * company name and the same address for one customer. The rule lives on the backend, which answers
 * 409 with `isDuplicate: true` and a ready-to-show message — every surface that saves an address
 * (address book, quote steppers, stop details, edit order request) reads the rejection through this
 * helper so the user gets the same wording wherever they hit it.
 */
export const getDuplicateAddressMessage = (error: any, fallback: string): string | null => {
    const data = error?.response?.data;

    if (!data?.isDuplicate) return null;

    return data.message || fallback;
};
